// Office contact info — edit here to update site-wide.
export const OFFICE_ADDRESS_EN =
  "Marlias street, facing Al Helou Police Station, Metco Center, Ground Floor, Beirut, Lebanon";
export const OFFICE_ADDRESS_AR =
  "شارع مار الياس، مقابل ثكنة الحلو، مركز ميتكو، الطابق الأرضي، بيروت، لبنان";
export const OFFICE_ADDRESS_FR =
  "Rue Marlias, face au poste de police Al Helou, Centre Metco, Rez-de-chaussée, Beyrouth, Liban";

export const OFFICE_MAP_URL = "https://maps.app.goo.gl/mbcRPRDvdS4sn7Le9";
export const OFFICIAL_EMAIL = "info@bobserviceslb.com";

// Multi-region WhatsApp contacts
export const CONTACTS = [
  { id: "lb1", label: "Lebanon 1", phone: "96178866746", display: "+961 78 866 746", flag: "lb" },
  { id: "lb2", label: "Lebanon 2", phone: "96181681314", display: "+961 81 681 314", flag: "lb" },
  { id: "tr",  label: "Turkey",    phone: "905531404733", display: "+90 553 140 47 33", flag: "tr" },
  { id: "ae",  label: "UAE",       phone: "971505183804", display: "+971 50 518 3804", flag: "ae" },
  { id: "cn",  label: "China",     phone: "8618823714205", display: "+86 188 2371 4205", flag: "cn" },
];

// Developer credit
export const DEVELOPER = {
  name: "BOB Services LB",
  whatsapp: "96178866746",
  display: "+961 78 866 746",
};
